import React, { ReactNode } from 'react';

interface ArticleContainerProps {
  children: ReactNode;
  className?: string;
}

export const ArticleContainer: React.FC<ArticleContainerProps> = ({ 
  children, 
  className = '' 
}) => {
  return (
    <article className={`
      bg-white/85 dark:bg-gray-900/85 backdrop-blur-md 
      border border-blue-200 dark:border-gray-800 rounded-xl 
      p-6 md:p-8 
      shadow-lg hover:shadow-xl 
      transition-shadow duration-300
      ${className}
    `}>
      {children}
    </article>
  );
};

export default ArticleContainer;
